import { AlertTriangle, CheckCircle, Clock, FlaskConical } from "lucide-react";
import { GROUP_STYLE, eventGroup, eventLabel } from "../eventLabels";

const fmtHora = (iso) => (iso ? new Date(iso).toLocaleTimeString("pt-BR", { hour: "2-digit", minute: "2-digit", second: "2-digit" }) : "—");
const fmtDia = (iso) => (iso ? new Date(iso).toLocaleDateString("pt-BR", { day: "2-digit", month: "2-digit" }) : "");
const brl = (v) => `R$ ${Number(v || 0).toFixed(2).replace(".", ",")}`;

/** Uma linha do log: cor pelo tipo, pedido legível, o que o evento significa, latência e situação. */
export default function EventoRow({ ev }) {
  const g = GROUP_STYLE[eventGroup(ev.full_code)] || GROUP_STYLE.outro;
  const erro = ev.process_error;
  return (
    <tr className={`border-b last:border-0 border-l-4 ${g.row}`}>
      <td className="p-3 align-top">
        <p className={`font-semibold flex items-center gap-1.5 ${g.text}`}>
          <span className={`w-2 h-2 rounded-full shrink-0 ${g.dot}`} />
          {eventLabel(ev.full_code)}
        </p>
        <p className="text-[10px] font-mono text-muted-foreground pl-3.5">{ev.full_code}</p>
      </td>
      <td className="p-3 align-top">
        {ev.pedido_codigo ? (
          <>
            <p className="font-mono font-bold text-sm">
              {String(ev.pedido_codigo).startsWith("#") ? ev.pedido_codigo : `#${ev.pedido_codigo}`}
              {ev.ifood_display_id && <span className="text-muted-foreground font-normal"> · iFood #{ev.ifood_display_id}</span>}
            </p>
            <p className="text-xs text-muted-foreground truncate max-w-[220px]">
              {ev.cliente_nome || "—"}{ev.pedido_total ? ` · ${brl(ev.pedido_total)}` : ""}
            </p>
          </>
        ) : (
          <p className="font-mono text-xs text-muted-foreground">{ev.order_id ? `${ev.order_id.slice(0, 8)}… (sem pedido no Núcleo)` : "—"}</p>
        )}
      </td>
      <td className="p-3 align-top text-sm">
        <p>{ev.detalhe || <span className="text-muted-foreground">—</span>}</p>
        <div className="flex items-center gap-1.5 mt-1 flex-wrap">
          {ev.simulated ? (
            <span className="inline-flex items-center gap-1 text-[10px] font-semibold px-1.5 py-0.5 rounded bg-orange-500/10 text-orange-600 dark:text-orange-400"><FlaskConical className="w-3 h-3" /> simulação</span>
          ) : ev.origem ? (
            <span className="text-[10px] font-semibold px-1.5 py-0.5 rounded bg-muted text-muted-foreground">origem: {ev.origem}</span>
          ) : null}
        </div>
      </td>
      <td className="p-3 align-top tabular-nums whitespace-nowrap">
        <p className="text-sm">{fmtHora(ev.received_at)}</p>
        <p className="text-[11px] text-muted-foreground">
          {fmtDia(ev.received_at)}
          {ev.latency_s != null && <span title="Tempo entre o iFood gerar o evento e o Núcleo receber"> · +{ev.latency_s}s</span>}
        </p>
      </td>
      <td className="p-3 align-top text-xs">
        <p className="flex items-center gap-1">
          {ev.acknowledged ? <CheckCircle className="w-3.5 h-3.5 text-green-500" /> : <Clock className="w-3.5 h-3.5 text-yellow-500" />}
          {ev.acknowledged ? "Confirmado ao iFood" : "Aguardando confirmação"}
        </p>
        <p className="flex items-center gap-1 mt-0.5">
          {erro ? <AlertTriangle className="w-3.5 h-3.5 text-red-500" /> : ev.processed ? <CheckCircle className="w-3.5 h-3.5 text-green-500" /> : <Clock className="w-3.5 h-3.5 text-yellow-500" />}
          {erro ? <span className="text-red-600 dark:text-red-400">Erro: {String(erro).slice(0, 90)}</span> : ev.processed ? "Processado no Núcleo" : "Pendente"}
          {ev.attempts > 0 && <span className="text-muted-foreground"> · {ev.attempts} tentativa(s)</span>}
        </p>
      </td>
    </tr>
  );
}
